window.emui = window.emui || {};
window.emui.logRocketConfig = {
  // enable: false,
  appId: 'fds38t/test-1izuw',
  rootHostname: '.vinothvk.com',
};
window.emui.dangerouslyOverrideSessionRecordingConsent = true;

/**
 * Creates an iframe microapp and appends it to the child apps container.
 * @param {*} src
 */
export const createIFramedMicroapp = (
  src,
  { width = '100%', height = '150px' } = {},
) => {
  const childAppsContainer = document.getElementById('child-apps-container');
  const urlParams = window.emuiLogrocket.buildLogRocketQueryParams();
  const iframe = document.createElement('iframe');
  iframe.src = `${src}?${urlParams}`;
  iframe.style.width = width;
  iframe.style.height = height;
  iframe.style.marginTop = '10px';
  const randomColor = `#${Math.floor(Math.random() * 16777215).toString(16)}`;
  iframe.style.border = `1px dashed ${randomColor}`;
  iframe.sandbox = 'allow-forms allow-scripts allow-same-origin';
  childAppsContainer.appendChild(iframe);
};
